export default __webpack_public_path__ + "static/bloomberg-4c36821e2f21158fc58d33210af79bcb.svg";